<template>
  <b-navbar
    toggleable="lg"
    type="dark"
    variant="info"
    class="app-header d-flex align-items-center justify-content-between position-fixed px-2 px-sm-0"
  >
    <!-- <b-navbar-brand to="/"> -->
      <b-navbar-brand :to="user ? '/' : null" :href="!user ? getAppLink : '/'">
      <img
        class="logo"
        src="../../../../ui/public/PhairifyLogoWhite.svg"
        alt="Phairify"
      />
      <h1 class="app_name">PHAIRIFY</h1>
    </b-navbar-brand>
    <navigation-menu :user-email="userEmail" :userName="userName">
      <template v-if="navMenuItems" slot="nav-items">
        <component :is="navMenuItems" />
      </template>
      <b-nav-item
        v-if="!isEmailInvalid"
        slot="extra-dropdown-items"
        class="mx-0"
        :to="
          $store.getters.userIsMSSRecruiter ? '/recruiter/profile' : '/profile'
        "
      >
        Edit Profile
      </b-nav-item>
    </navigation-menu>
  </b-navbar>
</template>

<script>
import NavigationMenu from '@/components/layouts/navigation-bar/NavigationMenu';
import AdminNavMenuItems from '@/components/layouts/admin/AdminNavMenuItems';
import { APP_LINK } from '@/store';

export default {
  name: 'NavigationLayout',
  components: {
    NavigationMenu,
    AdminNavMenuItems,
  },
  computed: {
    user: function () {
      return this.$store.state.user;
    },
    userEmail: function () {
      return this.user ? this.user.email : null;
    },
    userName: function () {
      return this.user ? (this.user.roles[0] == 'MSS_USER' ? this.user.username : this.user.first_name) : null;
    },
    isSignInVisible: function () {
      return !this.$store.getters.isAuthenticated;
    },
    navMenuItems: function () {
      if (
          this.$store.getters.userIsMSSUser ||
          this.$store.getters.userIsNonMSSUser ||
          this.$store.getters.userIsMSSRecruiter
      ) {
        return null;
      }
      if (this.$store.getters.userIsAdmin) {
        return AdminNavMenuItems.name;
      }
      return null;
    },
    isEmailInvalid: function () {
      return this.$store.getters.userHasInvalidEmail;
    },
    getAppLink: function () {
      return APP_LINK;
    }
  },
};
</script>

<style scoped lang="scss">
.app-header {
  left: 0;
  right: 0;
}
</style>
